import React from "react";
import { useNavigate } from "react-router-dom";

import { useLocalStorageState } from "../utils/useLocalStorage";

const AuthContext = React.createContext({});

export function AuthProvider(props) {
  const navigate = useNavigate();

  const [loggedInUser, setLoggedInUser] = useLocalStorageState("loggedInUser", {
    username: "farshid",
  });
  const [Token, setToken] = useLocalStorageState("academy-token", "");

  function logout() {
    setToken(undefined);
    setLoggedInUser(null);
    navigate("/");
  }

  async function authenticateUser(username, password) {
    let tempErrorMsg = "Can not Connect to Server";

    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const rawResult = await fetch(
        `${process.env.REACT_APP_END_POINT}api/auth/signin`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            username: username,
            password: password,
          }),
        }
      );

      if (!rawResult.ok) {
        let result = await rawResult.json();
        tempErrorMsg = result.msg;
        setToken("");
        throw new Error(tempErrorMsg);
      }

      let result = await rawResult.json();

      setToken(result.accessToken);

      setLoggedInUser({
        username: result.username,
        id: result.id,
        role: result.roles?.[0],
      });
    } catch (exception) {
      setLoggedInUser(null);
      setToken("");
      throw exception;
    }
  }

  function createHeader(isFormData) {
    let header = new Headers();
    if (!isFormData) {
      header.append("Content-Type", "application/json");
    }
    header.append("Authorization", "Bearer " + Token);
    return header;
  }

  function unAuthorizedCall(message) {
    logout();
    throw new Error(message);
  }

  const AuthenticatedServerCall = async ({
    entity,
    method,
    body,
    isFormData = false,
  }) => {
    try {
      let url = `${process.env.REACT_APP_END_POINT}${entity}`;

      // let decodedToken = jwt(Token);
      // if (new Date().getTime() / 1000 > decodedToken.exp) {
      //   logout();
      //   throw new Error("Token is expired!");
      // }

      let requestOptions = {
        method: method,
        headers: createHeader(isFormData),
        redirect: "follow",
        ...(body && isFormData
          ? { body }
          : body
          ? { body: JSON.stringify(body) }
          : {}),
      };

      let response = await fetch(url, requestOptions);

      if (response.status === 401) {
        const { message } = await response.json();
        unAuthorizedCall(message);
      }

      if (response.status === 403) {
        const { message } = await response.json();
        throw new Error(message);
      }

      if (response.ok) {
        // 204 doesn't have any content
        if (response.status === 204) {
          return true;
        } else {
          return await response.json();
        }
      } else {
        let result = await response.json();
        throw new Error(`${result.msg} - ${result.data}`);
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        loggedInUser,
        Token,
        AuthenticatedServerCall,
        logout,
        authenticateUser,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`);
  }

  return context;
}
